import React from 'react';
import { Phone, MapPin, Instagram } from 'lucide-react';
import { Separator } from './Separator';
export function Footer() {
  const navLinks = [{
    label: 'Services',
    href: '#services'
  }, {
    label: 'About',
    href: '#about'
  }, {
    label: 'Contact',
    href: '#contact'
  }];
  return <footer id="contact" className="w-full bg-brand-bg pt-16 pb-8" data-id="element-29">
      <div className="container mx-auto px-6" data-id="element-30">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-31">
          <div className="flex flex-col items-center md:items-start" data-id="element-32">
            <img src="https://cdn.magicpatterns.com/uploads/x1GHF6NPVyfoAJS1XwbkQu/phoenix-tree-experts.png" alt="Phoenix Tree Experts" className="w-32 h-32 mb-4" data-id="element-33" />
            <h3 className="font-heading-alt text-white text-xl font-bold" data-id="element-34">
              Phoenix Tree Experts
            </h3>
          </div>

          <div className="flex flex-col items-center" data-id="element-35">
            <h4 className="font-heading-alt text-white text-lg font-bold mb-4" data-id="element-36">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3" data-id="element-37">
              {navLinks.map(link => <a key={link.href} href={link.href} className="font-body text-white/70 hover:text-brand-green transition-colors text-center" data-id="element-38">
                  {link.label}
                </a>)}
            </nav>
          </div>

          <div className="flex flex-col items-center md:items-end" data-id="element-39">
            <h4 className="font-heading-alt text-white text-lg font-bold mb-4" data-id="element-40">
              Contact
            </h4>
            <div className="flex flex-col gap-3 items-center md:items-end" data-id="element-41">
              <a href="tel:6025525252" className="flex items-center gap-2 font-body text-white/90 hover:text-brand-green transition-colors" data-id="element-42">
                <Phone className="w-5 h-5" data-id="element-43" />
                <span data-id="element-44">602-552-5252</span>
              </a>
              <div className="flex items-center gap-2 font-body text-white/90" data-id="element-45">
                <MapPin className="w-5 h-5" data-id="element-46" />
                <span data-id="element-47">Phoenix Valley, AZ</span>
              </div>
              <a href="https://instagram.com/phoenixtreeexperts1" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 font-body text-white/90 hover:text-brand-green transition-colors" data-id="element-48">
                <Instagram className="w-5 h-5" data-id="element-49" />
                <span data-id="element-50">@phoenixtreeexperts1</span>
              </a>
            </div>
          </div>
        </div>

        <Separator className="bg-white/10 mb-6" data-id="element-51" />

        <div className="text-center font-body text-white/60 text-sm" data-id="element-52">
          © 2025 Phoenix Tree Experts. All rights reserved. | Managed by
          LetLois
        </div>
      </div>
    </footer>;
}